var render, staticRenderFns
import script from "./associated_position_three.vue?vue&type=script&lang=js"
export * from "./associated_position_three.vue?vue&type=script&lang=js"
import style0 from "./associated_position_three.vue?vue&type=style&index=0&id=62b7e4ac&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7e4ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b7e4ac')) {
      api.createRecord('62b7e4ac', component.options)
    } else {
      api.reload('62b7e4ac', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/role_manage/form/customer_user/associated_position_three.vue"
export default component.exports